import { PropsWithChildren } from 'react'
import { SsrContext, type SsrContextType } from './SsrContext'

export const SsrContextProvider = ({
  isMobileUA,
  processEnv,
  children,
}: PropsWithChildren<SsrContextType>) => {
  return (
    <SsrContext.Provider value={{ isMobileUA, processEnv }}>
      {children}
    </SsrContext.Provider>
  )
}
